import { TooltipOverflow } from "@data-display/wrapper//DetectOverflow/TooltipOverflow";
import { DetectOverflow } from "@data-display/wrapper/DetectOverflow";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import CheckIcon from "@mui/icons-material/Check";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { themeBBJ } from "@style/theme/material.theme";
import { Fragment } from "react";

/**
 * Group items by key value
 * @param {*} items
 * @param {*} key
 * @returns
 */
const groupBy = (items, key) =>
  items?.reduce(
    (result, item, index) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), { ...item, index }],
    }),
    {}
  );

/**
 * List to select item with render "label iconPlus" or "label iconCheck"
 * Possible to groupBy section
 * @param {String} props.id id of first div
 * @param {Number} props.total Total result for the hook
 * @param {Array} props.list List of result from the Hook
 * @param {Function} props.getItemLabel How to display item data
 * @param {Boolean} props.isLoading Is the hook loading
 * @param {Array} props.checkList List of checkbox that are checked (use indexes)
 * @param {Function} props.setCheckList Function to update checkList
 * @param {Object} props.sectionsTitle Object of key value with key => title
 * @param {Function} props.sectionItemKey Function to update checkList
 */
export const AddList = (props) => {
  const { id, list, getItemLabel, checkList, setCheckList, sectionsTitle, sectionItemKey, endItemAdornment } = props;

  const itemsBySection = groupBy(list, sectionItemKey);

  /**
   *
   * @param {*} index
   * @returns
   */
  const getItemChecked = (index) => {
    return checkList?.includes(index);
  };

  /**
   *
   * @param {*} index
   * @returns
   */
  const checkChange = (index) => {
    if (!checkList) return;
    const checkValue = checkList.find((check) => check === index);
    if (checkValue === undefined) {
      setCheckList([...checkList, index]);
    } else {
      setCheckList(checkList.filter((cl) => cl !== checkValue));
    }
  };

  /**
   * render of an item line
   * @param {*} item
   * @param {*} index
   * @returns
   */
  const renderItem = (item, index) => {
    return (
      <Stack direction="row" spacing={1}>
        <Box
          onClick={() => checkChange(index)}
          sx={{
            flex: "1 1 auto",
            overflow: "hidden",
            pt: 0.5,
            "&:hover": { cursor: "pointer" },
          }}
        >
          <DetectOverflow component={Typography} variant="body1" noWrap>
            <TooltipOverflow text={getItemLabel(item)} />
          </DetectOverflow>
        </Box>
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: "center",
          }}
        >
          {getItemChecked(index) ? (
            <CheckIcon
              fontSize="small"
              sx={{ color: themeBBJ.palette.success.main, "&:hover": { cursor: "pointer" } }}
              onClick={() => checkChange(index)}
            />
          ) : (
            <AddRoundedIcon
              fontSize="small"
              sx={{ color: themeBBJ.palette.primary.dark, "&:hover": { cursor: "pointer" } }}
              onClick={() => checkChange(index)}
            />
          )}
          {endItemAdornment && endItemAdornment(item, index)}
        </Stack>
      </Stack>
    );
  };

  return (
    <Box
      id={id}
      sx={{
        width: "100%",
      }}
    >
      {sectionsTitle &&
        Object.keys(sectionsTitle).map((section, index) => (
          <Fragment key={`list-section-${id}-${index}`}>
            {Array.isArray(itemsBySection[section]) && itemsBySection[section].length && (
              <>
                <Stack
                  sx={{
                    py: 0.5,
                  }}
                >
                  <Typography variant="h3">{sectionsTitle[section] || section}</Typography>
                  {itemsBySection[section]?.map((item) => renderItem(item, item.index))}
                </Stack>
                <Divider />
              </>
            )}
          </Fragment>
        ))}
      {!sectionsTitle && list.map((item, index) => renderItem(item, index))}
    </Box>
  );
};
